import { FormattedVerificationTransactionDetails } from "@idw-types/data/verification-transaction-details";

export enum VerificationTransactionDetailsActionTypes {
    SET_VERIFICATION_TRANSACTION_DETAILS_DATA_LOADING = "SET_VERIFICATION_TRANSACTION_DETAILS_DATA_LOADING",
    SET_VERIFICATION_TRANSACTION_DETAILS_DATA = "SET_VERIFICATION_TRANSACTION_DETAILS_DATA",
}

type SetVerificationTransactionDetailsDataLoadingAction = {
    type: VerificationTransactionDetailsActionTypes.SET_VERIFICATION_TRANSACTION_DETAILS_DATA_LOADING,
    payload: { isLoading: boolean };
};

export const setVerificationTransactionDetailsDataLoading = (
    isLoading: boolean
): SetVerificationTransactionDetailsDataLoadingAction => ({
    type: VerificationTransactionDetailsActionTypes.SET_VERIFICATION_TRANSACTION_DETAILS_DATA_LOADING,
    payload: { isLoading }
});

type SetVerificationTransactionDetailsDataAction = {
    type: VerificationTransactionDetailsActionTypes.SET_VERIFICATION_TRANSACTION_DETAILS_DATA,
    payload: { verificationTransactionDetails: FormattedVerificationTransactionDetails };
};

export const setVerificationTransactionDetailsData = (
    verificationTransactionDetails: FormattedVerificationTransactionDetails
): SetVerificationTransactionDetailsDataAction => ({
    type: VerificationTransactionDetailsActionTypes.SET_VERIFICATION_TRANSACTION_DETAILS_DATA,
    payload: { verificationTransactionDetails }
});

export type VerificationTransactionDetailsActions =
    SetVerificationTransactionDetailsDataLoadingAction |
    SetVerificationTransactionDetailsDataAction